import { RouteConfig } from "vue-router";

const ciudades: RouteConfig = {
  path: "/ciudades",
  name: "ciudades",
  component: () => import(/* webpackChunkName: "ciudades" */ "@/views/Ciudades.vue"),
};

export default ciudades;
